// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
import React from 'react';
import { useLocation } from 'wouter';
import { useI18n } from '../i18n';

const UpgradeModal = ({ onClose }) => {
  const { t } = useI18n();
  const [, setLocation] = useLocation();

  const handleUpgrade = () => {
    onClose();
    setLocation('/parametres?tab=billing');
  };

  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', backdropFilter: 'blur(2px)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: 'var(--bg-surface)', borderRadius: 12, border: '1px solid var(--gray)', padding: '24px 28px', maxWidth: 380, width: '100%', boxShadow: 'var(--shadow-md)' }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: 'var(--black)', marginBottom: 10 }}>🚀 {t('upgrade_modal_title')}</div>
        <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 20, lineHeight: 1.6 }}>{t('upgrade_modal_body')}</p>
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '8px 16px', borderRadius: 8, background: 'transparent', border: '1px solid var(--gray)', fontSize: 13, cursor: 'pointer', color: 'var(--black)' }}>
            {t('cancel')}
          </button>
          <button
            onClick={handleUpgrade}
            style={{ padding: '8px 16px', borderRadius: 8, background: 'var(--blue)', color: 'white', border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}
          >
            {t('upgrade_modal_cta')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;
